import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Banner from "../../components/Banner/Banner";
import Form from "../../components/Form/Form";
import EligibilityForm from "../../components/EligibilityForm/EligibilityForm.jsx"
import "./Home.css"
import about from "./../../images/image-mg-5.jpg"
import about1 from "./../../images/image-mg-4.jpg"
import card1 from "./../../images/card1.png"
import card2 from "./../../images/card2.png"
import card3 from "./../../images/card3.png"
import rightarrow from "./../../images/right_arrow.png"
import icon1 from "./../../images/Icon1.png"
import icon2 from "./../../images/Icon2.png"
import icon3 from "./../../images/Icon3.png"
import icon4 from "./../../images/Icon4.png"
import study1 from "./../../images/study1.png"
import study2 from "./../../images/study2.png"
import study3 from "./../../images/study3.png"
import study4 from "./../../images/study4.png"
import study5 from "./../../images/study5.png"
import study6 from "./../../images/study6.png"
import about_bor from "./../../images/tri_cor1.png"
import { Link, useLocation} from 'react-router-dom';
import useNavigation  from '../../utils/Navigation';
import React, { useEffect,useRef } from 'react';

import useIntersectionObserver from '../../utils/intersectionObserver';

const Home = () => {
    // js functions

    //utm parameter
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
    
        // Extracting and storing URL parameters in sessionStorage
        const paramsToStore = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_device'];
        const paramsObject = {};
    
        paramsToStore.forEach(param => {
          const value = searchParams.get(param);
          if (value) {
            paramsObject[param] = value;
          }
        });
    
        if (Object.keys(paramsObject).length > 0) {
          sessionStorage.setItem('utmParams', JSON.stringify(paramsObject));
        }
      }, [location.search]);

    const eligibilityRef = useRef(null);
    const isInView = useIntersectionObserver(eligibilityRef, { threshold: 0.1 });

    const navigateToSection = useNavigation();
    return (
        <>
            <Header />
            <Banner />
            <section className="goal coral-study">
	<div className="container">
		<div className="row">
			<h2>Why Consider Joining?</h2>
			<p>Taking part in a Myasthenia Gravis research study may allow you to access investigational therapies and contribute to ongoing scientific research. Participation is voluntary and subject to eligibility criteria.</p>
			<p>As a part of the trial, you will be assured:</p>
		</div>
	
	<div className="row">
		<div className="col-12 col-sm-4">
			<div className="study">
			<img src={study1} alt="Safety & Well-being"/>
			<h6>DEDICATED STUDY TEAM</h6> 
			<p>You will receive care from dedicated
doctors, nurses and study coordinators
throughout the process.</p>
			</div>
		</div>
		<div className="col-12 col-sm-4">
			<div className="study">
			<img src={study2} alt="Confidentiality" />
			<h6>Confidentiality</h6>
			<p>All information shared during the trial will be kept strictly confidential.</p>
			</div>
		</div>
		<div className="col-12 col-sm-4">
			<div className="study"> 
			<img src={study3} alt="Ethical Standards"/>
			<h6>Ethical Standards</h6>
			<p>We follow all the required protocols and ethical standards to ensure the integrity and validity of our findings.</p>
			</div>
		</div>
	
		<div className="col-12 col-sm-4">
			<div className="study">
				<img src={study4} alt="Thorough Medical Evaluation"/>
				<h6>Thorough Medical Evaluation</h6>
				<p>Patients will receive comprehensive medical assessments.</p>
			</div>
		</div>
		<div className="col-12 col-sm-4">
			<div className="study">
				<img src={study5} alt="Expense compensation"/>
				<h6>Expense compensation</h6>
				<p>Your participation is valuable. There are no costs to participate in the trial and 
you may be eligible for your travel costs to be covered. </p>
			</div>
		</div>
		<div className="col-12 col-sm-4">
			<div className="study">
				<img src={study6} alt="INFORMED CONSENT"/>
				<h6>INFORMED CONSENT</h6>
				<p>Your voice matters in the voluntary trial, informed consent ensures your
comfort and understanding.</p>
			</div>
		</div>
	</div>
    </div>
</section>
            <section className="about" id="aboutStudy">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-xl-6 about-img">
                        <img src={about} className="img-fluid" alt="..." />
                    </div>
                    <div className="col-sm-12 col-md-12 col-xl-6 about-txt">
                        <div className="col-sm-12">
                            <h2>ABOUT THE TRIAL</h2>
                            <p><strong>Clinical Trial for Individuals Living with Myasthenia Gravis (MG)</strong></p>
                            <p>We are inviting individuals diagnosed with Myasthenia Gravis (MG) to take part in a clinical research study. MG is a rare, chronic autoimmune neuromuscular condition that leads to varying degrees of muscle weakness, which can affect daily functioning.</p>
                            <p>This clinical trial aims to evaluate an investigational study drug to better understand its safety, potential effects, and optimal dosing in individuals with MG. If you or someone you care for is living with generalized myasthenia gravis and still facing muscle weakness, fatigue, or daily struggles, you’re not alone. The AURORA clinical trial is here to help.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="goal">
                <div className="container">
                    <div className="row">
                        <h2>GOALS OF THE TRIAL</h2>
                        <p><strong>The goals of the trial are to:</strong></p>
                        <p className="r_arrow">This study aims to confirm the findings from a previous clinical trial in a larger group of individuals with Myasthenia Gravis (MG) </p>
                        <p className="r_arrow">To evaluate how different doses of the investigational study drug may affect symptoms associated with MG.</p>
                    </div>
                </div>
            </section>
            <section ref={eligibilityRef} className="questionnaire" id="eligibility">
                <div className="row">
                    <div className="col">
                        <Form />     
                        {/* <EligibilityForm/> */}
                    </div>
                </div>
            </section>
            <section className="goal">
                <div className="container">
                    <div className="row">
                        <h2 className="text-center">Who Can PARTICIPATE In The TRIAL? </h2>
                        <p className="text-center"><strong>People diagnosed with Myasthenia Gravis (MG) who fulfill the trial’s inclusion criteria may be eligible to take part in this research study.</strong></p>
                    </div>
                </div>
            </section>
            <section className="about mt-0">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-xl-6 about-img">
                        <img src={about1} className="img-fluid" alt="..." />
                    </div>
                    <div className="col-sm-12 col-md-12 col-xl-6  about-txt">
                        <div className="col-sm-12">
                            <p><strong>To be able to take part in this trial, a patient must meet the following conditions:</strong></p>
                            <p className="r_arrow">Adults aged 18 years and older</p>
                            <p className="r_arrow">Have a diagnosis of generalized myasthenia gravis from a neurologist or neuromuscular specialist </p>

                            <p className="r_arrow">Have tested positive for anti-acetylcholine receptor (AChR) antibodies or a related antibody in the past 10 years</p>
                            <Link to = "/#eligibility" className="nav-link eligibility" onClick={() => navigateToSection('eligibility')} >
                                 <button>See if you qualify</button> 
                             </Link >
                            
                            <p className="r_arrow">Please note that this list of above conditions is not exhaustive. If you are eligible,
all further examinations conducted as part of the trial will take place at the
hospital/study centre under the supervision of a study physician. The study
physician will inform you whether you are eligible to participate in this study.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="participate">
                <h2 className="text-center">How to Participate in the trial</h2>
                <div className="container">
                    <div className="cards">
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <div className="card">
                                    <img src={card1} className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h5>Step 1</h5>
                                        <p className="card-text">Answer a few questions to check if
you qualify for the trial</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-4">
                                <div className="card">
                                    <img src={card2} className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h5>Step 2</h5>
                                        <p className="card-text">A registered nurse will call you to
ask you some additional questions
and see if you qualify</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-4">
                                <div className="card">
                                    <img src={card3} className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h5>Step 3</h5>
                                        <p className="card-text">If you qualify after talking to the
registered nurse, and are located
near a site, you will be scheduled for
a site visit</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Link to ="/#eligibility" className="nav-link eligibility" onClick={() => navigateToSection('eligibility')} >
                                 <button>See if you qualify</button> 
                    </Link >
                </div>
            </section>
            <section className="goal bg_green">
                <div className="container">
                    <div className="row">
                        <h2 className="text-center">wHAT CAN you EXPECT DURING THE trial
</h2>
                        <p className="text-center">Participation in the trial will take approximately '14 months'. During this period, you will have <br/> in-person study visits and check-in phone calls.</p>
                    </div>
                </div>
            </section>
            <section className="gray_content">
                <div className="container">
                    <img src={rightarrow} className="img-fluid right_arrow" alt="right arrow" />
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-3 col-xl-3">
                            <div className="card">
                                <img src={icon3} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <p className="card-text"><span className="card1">Part 1: </span>
                                    Screening (up to 2 months)</p>
                                    <ul>
                                        <li>Steps involved: </li>
                                        <li>1. Understand the study, and decide whether to consent</li>
                                        <li>2. Examinations to identify eligibility</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-xl-3">
                            <div className="card">
                                <img src={icon2} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <p className="card-text"><span className="card2"> Part 2: </span>
                                    Baseline: Determine Study Eligibility (1 day before treatment period)</p>
                                    <ul>
                                        <li>Steps involved:</li>
                                        <li>1. Treatment assignment (randomisation) or end of study, if not eligible</li>
                                        <li>2. Examinations for the study</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-xl-3">
                            <div className="card">
                                <img src={icon1} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <p className="card-text"><span className="card3">Part 3: </span>
                                    Treatment (10 months)</p>
                                    <ul>
                                        <li>Steps involved:</li>
                                        <li>1. Week A-B: Increasing dose</li>
                                        <li>2. Week C-D: Fixed dose</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-xl-3">
                            <div className="card">
                                <img src={icon4} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <p className="card-text"><span className="card4">Part 4: </span>
                                        Follow-up (2 months)</p>
                                    <ul>
                                        <li>Steps involved:</li>
                                        <li>1. End of treatment</li><li> 2. Two-week follow-up</li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="goal bg_green">
                <div className="container">
                    <div className="row">
                        <div className="study_drug">
                            <h3>About the study Medication </h3>
                            <p>In this trial, patients will receive either the study drug or placebo.</p>
                            <p>The treatment assignment will be randomly selected by a computer, which means the treatment you will receive will be based on chance. You will have a 50% chance of receiving the oral study drug and a 50% chance of receiving a placebo, which does not contain any active ingredient.</p>
                            <p>Add aditional details here
                            </p>
                                {/* <p>Add aditional details here</p> */}
                            <img src={about_bor} alt="about the study" className="bor_abt"/>
                        </div>
                    </div>
					</div>
                </section>
               


<section className="goal bg_green no_bg no_padd">	
	<div className="container">
		<div className="faq padd_no">
			<h4>Explore FAQs to learn more about the clinical trial </h4>
            <Link to="/faqs" alt="faqs"><button className="explore">Explore</button></Link>
			
		</div>
	</div>
</section>
{!isInView && (
<Link to = "/#eligibility"  onClick={() => navigateToSection('eligibility')} alt="sticky button"><button className="sticky_eligibility">See if you qualify</button></Link>
             )}
           <Footer />
        </> 
    )
}

export default Home;